import { FormEvent, useEffect, useState } from 'react'
import erroImg from '../../assets/img/erroFechar.png'
import { moedaMascara } from '../../helpers'
import { listaCategoriasResposta } from '../../interfaces/categorias'
import { listaCentrosRespostaPayload } from '../../interfaces/centros'
import { centroSelecionadoDfc } from '../../interfaces/dfc'
import { dadosDfcResposta } from '../../interfaces/relatorios'
import Permissoes from '../../middleware/Permissoes'
import { lisatarCategorias } from '../../services/categorias'
import { lisatarCentros } from '../../services/centros'
import { dfc } from '../../services/relatorios'
import LoadingBarra from '../LoadingBarra'
import Notificacoes from '../Notificacoes'
import { Button, Loader } from '../Styles'
import './dfc.css'

function Dfc() {

    const data = new Date()
    const ano = data.getFullYear()

    const [dadosDfc, setDadosDfc] = useState<dadosDfcResposta[]>([])
    const [centros, setCentros] = useState<listaCentrosRespostaPayload[]>([])
    const [categorias, setCategorias] = useState<listaCategoriasResposta[]>([])
    const [centro, setCentro] = useState("")
    const [anoDfc, setAnoDfc] = useState<string | number>(ano)
    const [processando, setProcessando] = useState(false)
    const [erro, setErro] = useState(false)
    const [exibirCentroResultado, setExibirCentroResultado] = useState(false)
    const [exibirCentroCusto, setExibirCentroCusto] = useState(false)
    const [exibirCategoriasInvestimento, setExibirCategoriasInvestimento] = useState(false)
    const [exibirCategoriasParticipacoes, setExibirCategoriasParticipacoes] = useState(false)
    const [centroResultadoSelecionado, setCentroResultadoSelecionado] = useState<centroSelecionadoDfc>({})
    const [centroCustoSelecionado, setCentroCustoSelecionado] = useState<centroSelecionadoDfc>({})


    const exibirCategoriasDfcInvestimento = () => setExibirCategoriasInvestimento(!exibirCategoriasInvestimento)
    const exibirCategoriasDfcParticipacoes = () => setExibirCategoriasParticipacoes(!exibirCategoriasParticipacoes)

    const exibirCentroDfcResultado = () => {

        setExibirCentroResultado(!exibirCentroResultado)
        setCentroResultadoSelecionado({})

        return
    }
    const exibirCentroDfcCutso = () => {

        setExibirCentroCusto(!exibirCentroCusto)
        setCentroCustoSelecionado({})

        return
    }

    const exibirCategoriasReceitasDfc = (index: number) => {

        setCentroResultadoSelecionado((prevetState) => ({
            ...prevetState,
            [index]: !prevetState[index]
        }))
    }

    const exibirCategoriasDespesasDfc = (index: number) => {

        setCentroCustoSelecionado((prevetState) => ({
            ...prevetState,
            [index]: !prevetState[index]
        }))
    }

    const buscarDadosDfc = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando(true)

        try {

            const params = {
                ano: anoDfc,
                idCentro: centro
            }

            const resposta = await dfc(params)

            if (resposta.status === 200) {
                setProcessando(false)

                return setDadosDfc(resposta.data)
            }

        } catch (error) {

            setProcessando(false)
            setErro(true)

            return setTimeout(() => {
                setErro(false)
            }, 2000)
        }
    }


    useEffect(() => {

        const buscarDadosDfc = async () => {

            setProcessando(true)

            try {

                const params = {
                    ano,
                    idCentro: ''
                }

                const resposta = await dfc(params)

                if (resposta.status === 200) {
                    setProcessando(false)

                    return setDadosDfc(resposta.data)
                }

            } catch (error) {

                setProcessando(false)
                setErro(true)

                return setTimeout(() => {
                    setErro(false)
                }, 2000)
            }
        }

        buscarDadosDfc()

    }, [ano])

    useEffect(() => {

        const buscarCentros = async () => {

            setProcessando(true)

            try {

                const params = {
                    descricao: '',
                    situacao: 'ativo'
                }

                const resposta = await lisatarCentros(params)

                if (resposta.status === 200) {
                    setCentros(resposta.data)
                    setProcessando(false)

                    return
                }

            } catch (error) {

                setProcessando(false)
                setErro(true)

                return setTimeout(() => {
                    setErro(false)
                }, 2000)
            }
        }

        buscarCentros()

    }, [])

    useEffect(() => {

        const buscarCategorias = async () => {

            setProcessando(true)

            try {

                const params = {
                    descricao: '',
                    situacao: ''
                }

                const resposta = await lisatarCategorias(params)

                if (resposta.status === 200) {
                    setCategorias(resposta.data)
                    setProcessando(false)

                    return
                }

            } catch (error) {

                setProcessando(false)
                setErro(true)

                return setTimeout(() => {
                    setErro(false)
                }, 2000)
            }
        }

        buscarCategorias()

    }, [])

    return (
        <Permissoes permissoes={['master', 'relatorio_dfc']}>
            <div id='paginaDfc'>
                {erro && <Notificacoes icone={erroImg} texto='Falha ao Processar a Solicitação' cor='erro' />}
                {processando && <LoadingBarra />}
                <section id='tituloDfcContainer'>
                    <h1>Demostração do Fluxo de Caixa</h1>
                    <div>
                        <form onSubmit={buscarDadosDfc}>
                            <span>
                                <label htmlFor="anoDfc">Filtrar pelo Ano</label>
                                <input
                                    id='anoDfc'
                                    value={anoDfc}
                                    onChange={(e) => setAnoDfc(e.target.value)}
                                    placeholder='Ex.: 2023'
                                    maxLength={4}
                                    minLength={4}
                                    pattern="^[0-9]{4}$"
                                    type="text"
                                    required />
                            </span>
                            <span>
                                <label htmlFor="centroResultado">Filrar pelo Centro de Resultado</label>
                                <select id="centroResultado" value={centro} onChange={(e) => setCentro(e.target.value)}>
                                    <option value="">Todos</option>
                                    {centros.filter(centro => centro.tipo === 'Centro de Resultado').map((centro) => (
                                        <option key={centro.id} value={centro.id}>{centro.descricao}</option>
                                    ))}
                                </select>
                            </span>
                            <span>
                                <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                    {!processando && 'Filtar Dados'}
                                    {processando && <Loader isLoading={processando} />}
                                </Button>
                            </span>
                        </form>
                    </div>
                </section>

                <section id='tabelaDfcContainer'>
                    <table id='tabelaListaContainer'>
                        <thead>
                            <tr>
                                <th className='ladoEsquerdoContent' align='left'></th>
                                <th align='right'>Jan</th>
                                <th align='right'>Fev</th>
                                <th align='right'>Mar</th>
                                <th align='right'>Abr</th>
                                <th align='right'>Mai</th>
                                <th align='right'>Jun</th>
                                <th align='right'>Jul</th>
                                <th align='right'>Ago</th>
                                <th align='right'>Set</th>
                                <th align='right'>Out</th>
                                <th align='right'>Nov</th>
                                <th align='right'>Dez</th>
                                <th className='ladoDireitoContent' align='right'>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='grupoDfc receitaOperacionalDfc' key={Math.random()} onClick={() => exibirCentroDfcResultado()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Recebimentos Operacionais</td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);
                                                
                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                    const soma = dadosDfc
                                        .filter(dado =>
                                            dado.lancamento.tipo === 'receita' &&
                                            dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                        )
                                        .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td className='ladoDireitoContent' align='right' title={(() => {
                                    const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                            }, 0)

                                        return moedaMascara(soma.toFixed(2));
                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                            }, 0)
                                            
                                        return soma.toFixed()

                                    })()}
                                </td>
                            </tr>
                            {centros.filter(centro => centro.tipo === 'Centro de Resultado').map((centro, index) => (
                                <>
                                    {exibirCentroResultado && <tr key={Math.random()} className='centroDfc' onClick={() => exibirCategoriasReceitasDfc(index)}>
                                        <td className='centroDfc primeiraColunaDfc'>{centro.descricao}</td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.idCentro === centro.id && 
                                                        dado.lancamento.tipo === 'receita' && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                            const soma = dadosDfc
                                                .filter(dado =>
                                                    dado.idCentro === centro.id &&
                                                    dado.lancamento.tipo === 'receita' &&
                                                    dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                )
                                                .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                            return moedaMascara(soma.toFixed(2));
                                        })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => dado.idCentro === centro.id && dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`))
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' className='ladoDireitoContent' title={(() => {
                                            const soma = dadosDfc
                                            .filter(dado => dado.idCentro === centro.id && dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                            }, 0)

                                                return moedaMascara(soma.toFixed(2));
                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                            .filter(dado => dado.idCentro === centro.id && dado.lancamento.tipo === 'receita' && dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`))
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                            }, 0)

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                    </tr>}
                                    {categorias.filter(categoria => categoria.tipo === 'receita' && categoria.centroResultado?.id === centro.id).map((categoria) => (
                                        <>
                                            {centroResultadoSelecionado[index] && <tr key={Math.random()}>
                                                <td className='categoriaDfc primeiraColunaDfc'>{categoria.descricao}</td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' className='ladoDireitoContent' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                            </tr>}
                                        </>
                                    ))}
                                </>
                            ))}

                            <tr className='grupoDfc' key={Math.random()} onClick={() => exibirCentroDfcCutso()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Despesas Operacionais</td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' className='ladoDireitoContent' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`) &&
                                                dado.categoria.centroCusto?.descricao !== "Participações" && 
                                                dado.categoria.centroCusto?.descricao !== "Investimentos"
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                            </tr>
                            {centros.filter(centro => centro.tipo === 'Centro de Custo').map((centro, index) => (
                                <>
                                    {exibirCentroCusto && <tr key={Math.random()} className='centroDfc' onClick={() => exibirCategoriasDespesasDfc(index)}>
                                        <td className='centroDfc primeiraColunaDfc'>{centro.descricao}</td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' className='ladoDireitoContent' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.centroCusto?.id === centro.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                    </tr>}
                                    {categorias.filter(categoria => categoria.tipo === 'despesa' && categoria.centroCusto?.id === centro.id).map((categoria) => (
                                        <>
                                            {centroCustoSelecionado[index] && <tr key={Math.random()}>
                                                <td className='categoriaDfc primeiraColunaDfc'>{categoria.descricao}</td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                                <td align='right' className='ladoDireitoContent' title={(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return moedaMascara(soma.toFixed(2))

                                                    })()}>
                                                    {(() => {
                                                        const soma = dadosDfc
                                                            .filter(dado => 
                                                                dado.categoria.id === categoria.id && 
                                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                            )
                                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                        return soma.toFixed()

                                                    })()}
                                                </td>
                                            </tr>}
                                        </>
                                    ))}
                                </>
                            ))}


                            <tr className='grupoDfc lucroOperacionalDfc' key={Math.random()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Caixa das Atividades Operacionais</td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                                <td align='right' className='ladoDireitoContent' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return moedaMascara((receita - despesa + investimentos + participacoes).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const investimentos = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const participacoes = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);


                                        return (receita - despesa + investimentos + participacoes).toFixed()

                                    })()}
                                </td>
                            </tr>

                            <tr className='grupoDfc' key={Math.random()} onClick={() => exibirCategoriasDfcInvestimento()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Investimentos</td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' className='ladoDireitoContent' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Investimentos' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                            </tr>

                            {categorias.filter(categoria => categoria.centroCusto?.descricao === 'Investimentos').map((categoria) => (
                                <>
                                    {exibirCategoriasInvestimento && <tr key={Math.random()}>
                                        <td className='categoriaDfc primeiraColunaDfc'>{categoria.descricao}</td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' className='ladoDireitoContent' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                    </tr>}
                                </>
                            ))}

                            <tr className='grupoDfc' key={Math.random()} onClick={() => exibirCategoriasDfcParticipacoes()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Participações</td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                                <td align='right' className='ladoDireitoContent' title={(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara(soma.toFixed(2))

                                    })()}>
                                    {(() => {
                                        const soma = dadosDfc
                                            .filter(dado => 
                                                dado.categoria.centroCusto?.descricao === 'Participações' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return soma.toFixed()

                                    })()}
                                </td>
                            </tr>

                            {categorias.filter(categoria => categoria.centroCusto?.descricao === 'Participações').map((categoria) => (
                                <>
                                    {exibirCategoriasParticipacoes && <tr key={Math.random()}>
                                        <td className='categoriaDfc primeiraColunaDfc'>{categoria.descricao}</td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                        <td align='right'  className='ladoDireitoContent' title={(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return moedaMascara(soma.toFixed(2))

                                            })()}>
                                            {(() => {
                                                const soma = dadosDfc
                                                    .filter(dado => 
                                                        dado.categoria.id === categoria.id && 
                                                        dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                                    )
                                                    .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                                return soma.toFixed()

                                            })()}
                                        </td>
                                    </tr>}
                                </>
                            ))}

                            <tr className='grupoDfc lucroLiquidoDfc' key={Math.random()}>
                                <td className='primeiraColuna primeiraColunaDfc'>Caixa Gerado no Período</td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `02/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `02/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `03/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `03/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `04/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `04/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `05/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `05/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `06/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `06/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `07/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `07/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `08/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `08/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `09/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `09/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `10/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `10/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `11/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `11/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao === `12/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao === `12/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                                <td align='right' className='ladoDireitoContent' title={(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return moedaMascara((receita - despesa).toFixed(2))

                                    })()}>
                                    {(() => {
                                        const receita = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'receita' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        const despesa = dadosDfc
                                            .filter(dado => 
                                                dado.lancamento.tipo === 'despesa' && 
                                                dado.lancamento.baixas.some(b => b.dataTransacao >= `01/${anoDfc}`)
                                            )
                                            .reduce((acc, dado) => {
                                                const baixasDoMes = dado.lancamento.baixas
                                                .filter(b => b.dataTransacao >= `01/${anoDfc}`)
                                                const totalBaixas = baixasDoMes.reduce((soma, b) => soma + Number(b.valor), 0)
                                                return acc + (totalBaixas / dado.lancamento.qtnRateios)
                                                }, 0);

                                        return (receita - despesa).toFixed()

                                    })()}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </Permissoes>
    )
}

export default Dfc
